import { setCookie, getCookie } from "./functions/Helper";

// Cookie name and lifetime per the UTM Tracking design doc (utm_tracking.md).
// Kept in its own module (no API imports) so the axios instances can read the
// tracking id without creating a circular import through API.js.
export const UTM_COOKIE = "casino_utm";
export const UTM_COOKIE_DAYS = 90;

export const saveUtmCookie = (utm) =>
  setCookie(UTM_COOKIE, encodeURIComponent(JSON.stringify(utm)), UTM_COOKIE_DAYS);

export const getStoredUTM = () => {
  try {
    return JSON.parse(getCookie(UTM_COOKIE) || "null") || {};
  } catch (e) {
    return {};
  }
};

// Tracking id returned by POST api/v1/utm, sent back on every request header.
export const getUtmTrackingId = () => getStoredUTM().trackingId || null;

export const clearUtmCookie = () => {
  setCookie(UTM_COOKIE, "", 0);
};
